module.exports = __webpack_public_path__ + "media/images/pc/top/hairstyle_header_bg@3x-9dfb69e6ed06a4733912feea07313c92.webp";